import { render, staticRenderFns } from "./LotTalk.vue?vue&type=template&id=cd46f5e6&scoped=true"
import script from "./LotTalk.vue?vue&type=script&lang=js"
export * from "./LotTalk.vue?vue&type=script&lang=js"
import style0 from "./LotTalk.vue?vue&type=style&index=0&id=cd46f5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd46f5e6",
  null
  
)

export default component.exports